<template>
  <div class="tooltip-trigger" @mouseenter="showTooltip" @mouseleave="hideTooltip">
    <q-icon name="help_outline" size="xs" class="help-icon" color="grey-7" />
    <span class="trigger-text">Get Started</span>

    <div v-if="isVisible" class="tooltip-overlay" :style="tooltipPosition">
      <div class="tooltip-content">
        <div class="tooltip-list">
          <div class="tooltip-item">
            <q-icon name="palette" size="xs" color="grey-6" class="item-icon" />
            <span>Style transfer (watercolor, sketch, painting)</span>
          </div>
          <div class="tooltip-item">
            <q-icon name="checkroom" size="xs" color="grey-6" class="item-icon" />
            <span>Modify clothing, objects, accessories</span>
          </div>
          <div class="tooltip-item">
            <q-icon name="text_fields" size="xs" color="grey-6" class="item-icon" />
            <span>Replace text in signs and labels</span>
          </div>
          <div class="tooltip-item">
            <q-icon name="landscape" size="xs" color="grey-6" class="item-icon" />
            <span>Change backgrounds and settings</span>
          </div>
          <div class="tooltip-item">
            <q-icon name="sync" size="xs" color="grey-6" class="item-icon" />
            <span>Maintain consistency across edits</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GetStartedTooltip',
  data() {
    return {
      isVisible: false,
      tooltipPosition: {
        top: '0px',
        left: '0px'
      }
    };
  },
  methods: {
    showTooltip(event) {
      this.isVisible = true;
      this.calculatePosition(event);
    },
    hideTooltip() {
      this.isVisible = false;
    },
    calculatePosition(event) {
      const rect = event.currentTarget.getBoundingClientRect();
      const tooltipWidth = 280; // Approximate tooltip width
      const tooltipHeight = 200; // Approximate tooltip height

      // Position to the right of the trigger by default
      let left = rect.right + 12;
      let top = rect.top;

      // Check if tooltip would go off screen to the right
      if (left + tooltipWidth > window.innerWidth) {
        left = rect.left - tooltipWidth - 12; // Position to the left instead
      }

      // Check if tooltip would go off screen at the bottom
      if (top + tooltipHeight > window.innerHeight) {
        top = window.innerHeight - tooltipHeight - 12;
      }

      // Check if tooltip would go off screen at the top
      if (top < 12) {
        top = 12;
      }

      this.tooltipPosition = {
        top: `${top}px`,
        left: `${left}px`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.tooltip-trigger {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  position: relative;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
}

.help-icon {
  flex-shrink: 0;
}

.trigger-text {
  @include inter-font($size: 12px, $color: var(--secondary-text-color));
  font-weight: 500;
}

.tooltip-overlay {
  position: fixed;
  z-index: 1000;
  pointer-events: none;
  width: auto;
  height: auto;
}

.tooltip-content {
  background: white;
  border-radius: 8px;
  padding: 16px;
  min-width: 260px;
  max-width: 320px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.tooltip-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.tooltip-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 4px 0;

  span {
    @include inter-font($size: 13px, $color: var(--main-text-color));
    line-height: 1.4;
  }
}

.item-icon {
  flex-shrink: 0;
  margin-top: 2px;
}
</style>
